import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `Combos/getEscandallos`, method: 'GET', body: null, token: token})
}